export const saveReviewNavigationBeforeSwitch = async ({
  currentSection,
  reviewMode,
  saveCurrent,
  completeCurrent,
  switchTo,
  targetSection,
}) => {
  if (!(await saveCurrent())) return false;
  if (reviewMode && !(await completeCurrent(currentSection))) return false;

  switchTo(targetSection);
  return true;
};
